import { render, staticRenderFns } from "./FormTipsPrudence.vue?vue&type=template&id=8070785c"
import script from "./FormTipsPrudence.vue?vue&type=script&lang=js"
export * from "./FormTipsPrudence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports